import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material';

const QuantityEditDialog = ({ open, onClose, onSave, product, value, onChange }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        Edytuj stan magazynowy - {product?.name}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="Nowa ilość"
            type="number"
            value={value}
            onChange={onChange}
            sx={{ mb: 2 }}
            inputProps={{ min: 0 }}
          />
          <Typography variant="body2" color="text.secondary">
            Aktualny stan: {product?.quantity || 0}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Anuluj
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!value || isNaN(parseInt(value)) || parseInt(value) < 0}
        >
          Zapisz zmiany
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuantityEditDialog; 